import litesseraLux from "./litessera-lux.json" with { type: "json" };
import venus from "./venus.json" with { type: "json" };
import spike from "./spike.json" with { type: "json" };
import ripes from "./ripes.json" with { type: "json" };
import rars from "./rars.json" with { type: "json" };
import rocket from "./rocket.json" with { type: "json" };
import boom from "./boom.json" with { type: "json" };
import xiangshan from "./xiangshan.json" with { type: "json" };
import ibex from "./ibex.json" with { type: "json" };
import picorv32 from "./picorv32.json" with { type: "json" };
import vexriscv from "./vexriscv.json" with { type: "json" };

export const WIKI = [
  litesseraLux,
  venus,
  spike,
  ripes,
  rars,
  rocket,
  boom,
  xiangshan,
  ibex,
  picorv32,
  vexriscv,
];
